<style>
    .c-form-builder-row {
        background-color: #fff;
        min-height: 100px;
    }

    .c-form-builder-col {
        border: 1px solid #ddd;
    }

    .c-form-builder-col:hover {
        border: 1px solid blue
    }

</style>

<template>
    <b-row>
        <b-col :lg="dataColLg">
            <b-button class="btn-sm" @click="onAddRowClick"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Nouvelle rangée')}}
            </b-button>
            <hr/>
            <b-alert variant="light" show v-if="dataRows.length === 0">
                {{Core.Definition.getDefinition('Vous devez ajouter une rangée pour commencer.')}}
            </b-alert>
            <Draggable v-if="dataRows.length > 0" v-model="dataRows"
                       @end="onChange"
                       handle=".c-drag-handle-row"
                       ghost-class="ghost">
                <transition-group
                        type="transition"
                        name="flip-list">
                    <b-card class="mt-1 c-form-builder-row" no-body :key="'row' + rowIndex"
                            v-for="row, rowIndex in dataRows">

                        <div slot="header">
                            {{Core.Definition.getDefinition('Rangée')}} {{rowIndex+1}}
                            <div class="card-header-actions">
                                <div>
                                    <b-dropdown class="card-header-action btn-setting btn-sm mr-2" variant=" p-0">
                                        <template slot="button-content">
                                            {{Core.Definition.getDefinition('Colonnes')}}
                                        </template>
                                        <b-dropdown-item @click="onDisplayColumnClick(rowIndex, 1)">1</b-dropdown-item>
                                        <b-dropdown-item @click="onDisplayColumnClick(rowIndex, 2)">2</b-dropdown-item>
                                        <b-dropdown-item @click="onDisplayColumnClick(rowIndex, 3)">3</b-dropdown-item>
                                        <b-dropdown-item @click="onDisplayColumnClick(rowIndex, 4)">4</b-dropdown-item>
                                    </b-dropdown>
                                    <b-link @click="onTrashRowClick(rowIndex)" href="#"
                                            class="mr-2 card-header-action btn-setting">
                                        <i class="fa text-danger fa-trash"></i>
                                    </b-link>
                                    <b-link href="#" class="mr-2 c-drag-handle-row">
                                        <i class="fa fa-arrows"></i>
                                    </b-link>
                                </div>
                            </div>
                        </div>

                        <b-card-body>

                            <b-alert variant="light" show v-if="dataRows[rowIndex].cols.length === 0">
                                {{Core.Definition.getDefinition('Vous devez ajouter une ou plusieurs colonnes.')}}
                            </b-alert>

                            <Draggable
                                    v-if="dataRows[rowIndex].cols.length > 0"
                                    v-model="dataRows[rowIndex].cols"
                                    handle=".c-drag-handle-col"
                                    @end="onChange"
                                    ghost-class="ghost">
                                <transition-group
                                        tag="b-row"
                                        type="transition"
                                        name="flip-list">
                                    <b-col :key="'col' + colIndex" v-if="col.display == true" class="c-drag-col"
                                           v-for="col, colIndex in dataRows[rowIndex].cols">
                                        <b-card class="c-form-builder-col">

                                            <div class="c-form-builder-header-white" slot="header">
                                                <label v-if="col.label == ''">
                                                    {{Core.Definition.getDefinition('Colonne')}} {{colIndex+1}}
                                                </label>
                                                <label v-if="col.label != ''">
                                                    {{col.label}}
                                                </label>
                                                <div class="card-header-actions">
                                                    <b-link
                                                            class="btn-setting mr-3" href="#"
                                                            @click="onEditColumnClick(rowIndex, colIndex)">
                                                        <i class="fa fa-edit"></i>
                                                    </b-link>
                                                    <b-link href="#" class="c-drag-handle-col">
                                                        <i class="fa fa-arrows"></i>
                                                    </b-link>
                                                </div>
                                            </div>

                                            <b-link v-if="dataRows[rowIndex].cols[colIndex].fields.length === 0"
                                                    class="btn-setting" href="#"
                                                    @click="onAddFieldClick(rowIndex, colIndex)">
                                                <i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Champ')}}
                                            </b-link>

                                            <Draggable
                                                    v-model="dataRows[rowIndex].cols[colIndex].fields"
                                                    group="field"
                                                    @end="onChange"
                                                    handle=".c-drag-handle-field"
                                                    ghost-class="ghost">
                                                <div v-if="dataRows[rowIndex].cols[colIndex].fields.length > 0"
                                                       :key="'field' + fieldIndex"
                                                       v-for="field, fieldIndex in dataRows[rowIndex].cols[colIndex].fields">

                                                    <div lg="3">
                                                        <div class="text-right">
                                                            <b-link @click="onEditFieldClick(rowIndex, colIndex)"
                                                                    href="#" class="mr-3">
                                                                <i class="fa text-info fa-edit"></i>
                                                            </b-link>
                                                            <b-link @click="onTrashFieldClick(rowIndex, colIndex)"
                                                                    href="#" class="mr-3">
                                                                <i class="fa text-danger fa-trash"></i>
                                                            </b-link>
                                                            <b-link href="#" class="c-drag-handle-field">
                                                                <i class="fa fa-arrows"></i>
                                                            </b-link>
                                                        </div>
                                                    </div>

                                                    <div lg="9">
                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeImage">
                                                            <InputFiles
                                                                    :id="'fieldText' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    :multiple="false"
                                                                    :allowedTypes="Core.File.imageTypes()"
                                                                    :placeholder="Core.Definition.getDefinition('Valeur par défaut')"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description"
                                                                    :thumbnailWidth="1200"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"></InputFiles>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeText">
                                                            <InputText
                                                                    :id="'fieldText' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :placeholder="Core.Definition.getDefinition('Valeur par défaut')"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputText>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeCheckbox">
                                                            <InputCheckbox
                                                                    :id="'fieldCheckbox' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :labelCols="6"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputCheckbox>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeHTML">
                                                            <InputEditor
                                                                    :id="'fieldHTML' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputEditor>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeLongText">
                                                            <InputLongText
                                                                    :id="'fieldLongText' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :placeholder="Core.Definition.getDefinition('Valeur par défaut')"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputLongText>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeEditor">
                                                            <InputEditor
                                                                    :id="'fieldEditor' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :placeholder="Core.Definition.getDefinition('Valeur par défaut')"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputEditor>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeSelect">
                                                            <InputSelect
                                                                    :id="'fieldSelect' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :options="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].data.selectOptions"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputSelect>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeDate">
                                                            <InputDate
                                                                    :id="'fieldDate' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :placeholder="Core.Definition.getDefinition('Valeur par défaut')"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputDate>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeTime">
                                                            <InputTime
                                                                    :id="'fieldTime' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputTime>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeSignature">
                                                            <InputSignature
                                                                    :id="'fieldSignature' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputSignature>
                                                        </div>

                                                        <div v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeSignatureImage">
                                                            <InputSignatureImage
                                                                    :id="'fieldSignatureImage' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"
                                                                    v-model="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue"
                                                                    :label="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].label + ' (id:' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id + ')'"
                                                                    :description="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].description">
                                                            </InputSignatureImage>
                                                        </div>

                                                        <div class="hot-table-container" v-if="dataRows[rowIndex].cols[colIndex].fields[fieldIndex].type === Core.Value.typeSpreadsheet">
                                                            <div :id="'hotTable' + dataRows[rowIndex].cols[colIndex].fields[fieldIndex].id"></div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Draggable>

                                        </b-card>
                                    </b-col>
                                </transition-group>
                            </Draggable>
                        </b-card-body>
                    </b-card>
                </transition-group>
            </Draggable>
            <ModalConfirm
                    ref="modalConfirmTrashRow"
                    @onConfirm="onConfirmTrashRow"
                    :caption="Core.Definition.getDefinition('Suppression rangée')"
                    :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette rangée?')">
            </ModalConfirm>
            <ModalConfirm ref="modalConfirmTrashField"
                          @onConfirm="onConfirmTrashField"
                          :caption="Core.Definition.getDefinition('Suppression champ')"
                          :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce champ?')">
            </ModalConfirm>
            <ModalFormBuilderField
                    ref="modalFormField"
                    @onInitSuccess="onInitSuccessFormBuilderField"
                    :options="formBuilderFieldOptions">
                <slot slot="formButtons">
                    <b-button type="button" @click="onSaveFieldClick" variant="success">
                        {{Core.Definition.getDefinition('Enregistrer')}}
                    </b-button>
                </slot>
            </ModalFormBuilderField>
            <ModalFormBuilderColumn
                    ref="modalFormColumn"
                    @onInitSuccess="onInitSuccessFormBuilderColumn"
                    :options="formBuilderColumnOptions">
                <slot slot="formButtons">
                    <b-button type="button" @click="onSaveClickFormBuilderColumn" variant="success">
                        {{Core.Definition.getDefinition('Enregistrer')}}
                    </b-button>
                </slot>
            </ModalFormBuilderColumn>
        </b-col>
        <b-col v-if="listBuilder||titleBuilder||searchBuilder" lg="4">
            <b-card v-if="titleBuilder">
                <div slot="header">
                    {{Core.Definition.getDefinition('Titre')}}
                </div>
                <b-list-group>
                    <Draggable
                            v-model="dataTitle"
                            handle=".list-drag-handle-row"
                            ghost-class="ghost">
                        <b-list-group-item :key="'fieldTitle' + fieldIndex" v-for="field, fieldIndex in dataTitle">
                            <input v-model="field.selected" type="checkbox" class="mr-2"/>
                            {{field.label}}
                            <b-link href="#" class="mr-2 list-drag-handle-row pull-right">
                                <i class="fa fa-arrows"></i>
                            </b-link>
                        </b-list-group-item>
                    </Draggable>
                </b-list-group>
            </b-card>
            <b-card v-if="listBuilder">
                <div slot="header">
                    {{Core.Definition.getDefinition('Colonnes')}}
                </div>
                <b-list-group>
                    <Draggable
                            v-model="dataList"
                            handle=".list-drag-handle-row"
                            ghost-class="ghost">
                            <b-list-group-item :key="'fieldList' + fieldIndex" v-for="field, fieldIndex in dataList">
                                <input v-model="field.selected" type="checkbox" class="mr-2"/>
                                {{field.label}}
                                <b-link href="#" class="mr-2 list-drag-handle-row pull-right">
                                    <i class="fa fa-arrows"></i>
                                </b-link>
                            </b-list-group-item>
                    </Draggable>
                </b-list-group>
            </b-card>
            <b-card v-if="searchBuilder">
                <div slot="header">
                    {{Core.Definition.getDefinition('Champs de recherche')}}
                </div>
                <b-list-group>
                    <Draggable
                            v-model="dataSearch"
                            handle=".list-drag-handle-row"
                            ghost-class="ghost">
                        <b-list-group-item :key="'fieldSearch' + fieldIndex" v-for="field, fieldIndex in dataSearch">
                            <input v-model="field.selected" type="checkbox" class="mr-2"/>
                            {{field.label}}
                            <b-link href="#" class="mr-2 list-drag-handle-row pull-right">
                                <i class="fa fa-arrows"></i>
                            </b-link>
                        </b-list-group-item>
                    </Draggable>
                </b-list-group>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import Draggable from 'vuedraggable'
    import ModalFormBuilderField from './ModalFormBuilderField'
    import ModalFormBuilderColumn from './ModalFormBuilderColumn'
    import ModalConfirm from './ModalConfirm'
    import ModalTrash from './ModalTrash'
    import InputText from './InputText'
    import InputCheckbox from './InputCheckbox'
    import InputHTML from './InputHTML'
    import InputEditor from './InputEditor'
    import InputLongText from './InputLongText'
    import Spreadsheet from './Spreadsheet'
    import InputDate from './InputDate'
    import InputTime from './InputTime'
    import InputSelect from './InputSelect'
    import InputMultiSelect from './InputMultiSelect'
    import InputFiles from './InputFiles'
    import InputItems from './InputItems'
    import InputSignature from './InputSignature'
    import InputSignatureImage from './InputSignatureImage'
    import { HotTable } from '@handsontable/vue';

    export default {
        name: 'FormBuilder',
        components: {
            Draggable,
            ModalFormBuilderField,
            ModalFormBuilderColumn,
            ModalConfirm,
            ModalTrash,
            InputText,
            InputCheckbox,
            InputHTML,
            InputEditor,
            InputLongText,
            Spreadsheet,
            InputDate,
            InputTime,
            InputSelect,
            InputMultiSelect,
            InputFiles,
            InputItems,
            HotTable,
            InputSignature,
            InputSignatureImage
        },
        props: {
            listBuilder: {
                type: Boolean,
                default: false
            },
            searchBuilder: {
                type: Boolean,
                default: false
            },
            titleBuilder: {
                type: Boolean,
                default: false
            },
            formBuilderFieldOptions: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            get: '/'
                        }
                    }
                }
            },
            formBuilderColumnOptions: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            get: '/'
                        }
                    }
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataRows = this.value
                }
            }
        },
        mounted() {
            if (this.listBuilder) {
                this.dataColLg = 8
            }
            this.dataInstanceId = this.instanceId
            this.dataRows = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataRows: [],
                dataInstanceId: '',
                dataDragRows: [],
                dataTrashRow: {
                    rowIndex: ''
                },
                dataTrashField: {
                    rowIndex: '',
                    colIndex: ''
                },
                dataAddField: {
                    rowIndex: '',
                    colIndex: ''
                },
                dataEditField: {
                    rowIndex: '',
                    colIndex: ''
                },
                dataEditColumn: {
                    rowIndex: '',
                    colIndex: ''
                },
                dataList: [],
                dataTitle: [],
                dataSearch: [],
                dataColLg: 12,
                dataSpreadsheet: {
                    mergeCells: [],
                    manualColumnResize: true,
                    rowHeaders: true,
                    colHeaders: true,
                    width: '100%',
                    afterInit(a) {},
                    cells: function(row,col) {},
                    afterMergeCells: function(cellRange, mergeParent, a, b) {},
                    afterUnmergeCells: function(cellRange, a, b) {
                        console.log(this)
                    },
                    afterSetCellMeta(row, column, key, value) {},
                    contextMenu: true
                }
            }
        },
        computed: {
            list: {
                set(val) {
                    this.dataList = val
                },
                get() {
                    let list = []
                    for(let field in this.dataList) {
                        field = this.dataList[field]
                        if (field.selected) {
                            list.push(field.id)
                        }
                    }
                    return list
                }
            },
            title: {
                set(val) {
                    this.dataTitle = val
                },
                get() {
                    let title = []
                    for(let field in this.dataTitle) {
                        field = this.dataTitle[field]
                        if (field.selected) {
                            title.push(field.id)
                        }
                    }
                    return title
                }
            },
            search: {
                set(val) {
                    this.dataSearch = val
                },
                get() {
                    let search = []
                    for(let field in this.dataSearch) {
                        field = this.dataSearch[field]
                        if (field.selected) {
                            search.push(field.id)
                        }
                    }
                    return search
                }
            }
        },
        methods: {
            onDisplayColumnClick(rowIndex, count) {
                for (let colIndex = 0; colIndex < 4; colIndex++) {
                    if (colIndex < count) {
                        this.dataRows[rowIndex].cols[colIndex].display = true
                    } else {
                        this.dataRows[rowIndex].cols[colIndex].display = false
                    }
                }
            },
            onAddRowClick() {

                if (this.dataRows === null || this.dataRows === undefined) {
                    this.dataRows = []
                }

                this.dataRows.push(
                    {
                        cols: [
                            {
                                label: '',
                                display: false,
                                fields: []
                            },
                            {
                                label: '',
                                display: false,
                                fields: []
                            },
                            {
                                label: '',
                                display: false,
                                fields: []
                            },
                            {
                                label: '',
                                display: false,
                                fields: []
                            }
                        ]
                    }
                )
            },
            onTrashRowClick(rowIndex) {
                this.dataTrashRow.rowIndex = rowIndex
                this.$refs.modalConfirmTrashRow.open = true
            },
            onConfirmTrashRow() {
                this.dataRows.splice(this.dataTrashRow.rowIndex, 1)
            },
            onTrashFieldClick(rowIndex, colIndex) {
                this.dataTrashField.rowIndex = rowIndex
                this.dataTrashField.colIndex = colIndex
                this.$refs.modalConfirmTrashField.open = true
            },
            onConfirmTrashField() {
                if (this.dataRows[this.dataTrashField.rowIndex].cols[this.dataTrashField.colIndex].fields[0] !== undefined) {
                    let field = this.dataRows[this.dataTrashField.rowIndex].cols[this.dataTrashField.colIndex].fields[0]
                    let fieldListIndex = Core.Array.findIndexByKey(this.dataList, 'id', field.id)
                    if (fieldListIndex !== false) {
                        this.dataList.splice(fieldListIndex, 1)
                    }
                }
                this.dataRows[this.dataTrashField.rowIndex].cols[this.dataTrashField.colIndex].fields = []
            },
            onInitSuccessFormBuilderField(data) {
                if (this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields[0] !== undefined) {
                    let savedField = this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields[0]
                    let field = {
                        id: savedField.id,
                        type: Core.Select.select(savedField.type, Core.Value.fieldOptions()),
                        label: savedField.label,
                        description: savedField.description,
                    }
                    this.$refs.modalFormField.dataSpreadsheetValue = savedField.value
                    this.$refs.modalFormField.$refs.dynamicForm.$refs.form.form = field
                    this.$refs.modalFormField.isRequired = Core.Value.decode(savedField.isRequired, Core.Value.typeCheckbox)

                    if (savedField.data.spreadsheet !== undefined) {
                        this.$refs.modalFormField.spreadsheet = savedField.data.spreadsheet
                    }

                    if (savedField.data.selectOptions !== undefined) {
                        this.$refs.modalFormField.selectOptions = savedField.data.selectOptions
                    } else {
                        this.$refs.modalFormField.selectOptions = []
                    }

                }
            },
            onAddFieldClick(rowIndex, colIndex) {
                this.dataAddField.rowIndex = rowIndex
                this.dataAddField.colIndex = colIndex
                this.$refs.modalFormField.resetOptions()
                this.$refs.modalFormField.open = true
            },
            onEditFieldClick(rowIndex, colIndex) {
                this.dataAddField.rowIndex = rowIndex
                this.dataAddField.colIndex = colIndex

                let field = this.dataRows[rowIndex].cols[colIndex].fields[0]
                this.$refs.modalFormField.open = true
                this.$refs.modalFormField.resetOptions(field)
            },
            onSaveFieldClick() {
                let form = this.$refs.modalFormField.$refs.dynamicForm.$refs.form
                let spreadsheetValue = this.$refs.modalFormField.dataSpreadsheetValue
                let fieldRefs = form.fieldRefs

                let id = fieldRefs.id.dataValue
                if (id === '') {
                    id = Core.Text.generateHash()
                }

                let isRequired = this.$refs.modalFormField.isRequired
                let selectOptions = this.$refs.modalFormField.selectOptions
                let spreadsheet = this.$refs.modalFormField.spreadsheet

                let defaultValue = ''
                if(this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields !== undefined) {
                    if (this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields[0] !== undefined) {
                        if (this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields[0].defaultValue !== undefined) {
                            defaultValue = this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields[0].defaultValue
                        }
                    }
                }

                let value = null

                let rowCount = 6

                let type = Core.Select.value(fieldRefs.type.dataValue)

                switch(type) {
                    case Core.Value.typeSignatureImage:
                        value = []
                        defaultValue = []
                        break
                    case Core.Value.typeSelect:
                        defaultValue = Core.Select.value(defaultValue)
                        break
                    case Core.Value.typeSpreadsheet:

                         rowCount = 6
                        let colCount = 6

                        if (spreadsheet.settings !== undefined && spreadsheet.settings.rowCount !== undefined) {
                            rowCount = spreadsheet.settings.rowCount
                        }
                        if (spreadsheet.settings !== undefined && spreadsheet.settings.colCount !== undefined) {
                            colCount = spreadsheet.settings.colCount
                        }

                        let rows = []

                        for(let r = 0; r < rowCount; r++) {
                            let col = []
                            for(let c = 0; c < colCount; c++) {
                                let value = ''
                                if(spreadsheetValue !== undefined) {
                                    if(spreadsheetValue[r] !== undefined) {
                                        if(spreadsheetValue[r][c] !== undefined) {
                                            value = spreadsheetValue[r][c]
                                        }
                                    }
                                }
                                col.push(value)
                            }
                            rows.push(col)
                        }

                        defaultValue = rows

                        /*
                        if (defaultValue === '') {
                            defaultValue = rows
                        } else {
                            if (!Array.isArray(defaultValue)) {
                                defaultValue = JSON.parse(defaultValue)
                            }
                        }

                        if (!Array.isArray(defaultValue)||(Array.isArray(defaultValue)&&defaultValue.length === 0)) {
                            defaultValue = rows
                        }*/

                        if (spreadsheet.settings === undefined) {
                            spreadsheet.settings = {
                                mergeCells: [],
                                colsWidth: []
                            }
                        }

                        if (spreadsheet.settings.mergeCells === undefined) {
                            spreadsheet.settings.mergeCells = []
                        }

                        if (spreadsheet.settings.colsWidth === undefined) {
                            spreadsheet.settings.colsWidth = []
                        }

                        value = defaultValue

                        break
                }

                let field = {
                    id: id,
                    type: type,
                    label: fieldRefs.label.dataValue,
                    description: fieldRefs.description.dataValue,
                    isRequired: isRequired,
                    defaultValue: defaultValue,
                    value: value,
                    data: {
                        selectOptions: selectOptions,
                        spreadsheet: spreadsheet
                    }
                }

                let fieldList = {
                    id: id,
                    type: Core.Select.value(fieldRefs.type.dataValue),
                    label: fieldRefs.label.dataValue
                }

                let fieldSearch = {
                    id: id,
                    type: Core.Select.value(fieldRefs.type.dataValue),
                    label: fieldRefs.label.dataValue
                }

                let fieldTitle = {
                    id: id,
                    type: Core.Select.value(fieldRefs.type.dataValue),
                    label: fieldRefs.label.dataValue
                }

                let fieldListIndex = Core.Array.findIndexByKey(this.dataList, 'id', fieldList.id)
                if (fieldListIndex === false) {
                    this.dataList.push(fieldList)
                } else {
                    let fieldListSelected = this.dataList[fieldListIndex].selected
                    this.dataList[fieldListIndex] = fieldList
                    this.dataList[fieldListIndex].selected = fieldListSelected
                }

                let fieldTitleIndex = Core.Array.findIndexByKey(this.dataTitle, 'id', fieldTitle.id)
                if (fieldTitleIndex === false) {
                    this.dataTitle.push(fieldTitle)
                } else {
                    let fieldTitleSelected = this.dataTitle[fieldTitleIndex].selected
                    this.dataTitle[fieldTitleIndex] = fieldTitle
                    this.dataTitle[fieldTitleIndex].selected = fieldTitleSelected
                }

                let fieldSearchIndex = Core.Array.findIndexByKey(this.dataSearch, 'id', fieldSearch.id)
                if (fieldSearchIndex === false) {
                    this.dataSearch.push(fieldSearch)
                } else {
                    let fieldSearchSelected = this.dataSearch[fieldSearchIndex].selected
                    this.dataSearch[fieldSearchIndex] = fieldSearch
                    this.dataSearch[fieldSearchIndex].selected = fieldSearchSelected
                }

                this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields = []
                this.dataRows[this.dataAddField.rowIndex].cols[this.dataAddField.colIndex].fields.push(field)

                this.$nextTick(function () {
                    if (field.type === Core.Value.typeSpreadsheet) {
                        let id = field.id
                        id = 'hotTable' + id
                        let container = document.getElementById(id)
                        if (container.hotInstance === undefined) {
                            Core.Spreadsheet.init(container, field)
                        } else {
                            container.hotInstance.loadData(field.value)
                        }

                        container.style.height = (26 * rowCount) + 'px'
                    }
                })

                this.$refs.modalFormField.open = false
            },
            onChange() {
                this.$forceUpdate()
            },
            onInitSuccessFormBuilderColumn(data) {
                if (this.dataRows[this.dataEditColumn.rowIndex].cols[this.dataEditColumn.colIndex] !== undefined) {
                    let col = this.dataRows[this.dataEditColumn.rowIndex].cols[this.dataEditColumn.colIndex]
                    this.$refs.modalFormColumn.$refs.dynamicForm.$refs.form.form.label = col.label
                }
            },
            onSaveClickFormBuilderColumn() {
                let form = this.$refs.modalFormColumn.$refs.dynamicForm.$refs.form
                let fieldRefs = form.fieldRefs
                let label = fieldRefs.label.dataValue
                this.dataRows[this.dataEditColumn.rowIndex].cols[this.dataEditColumn.colIndex].label = label
            },
            onEditColumnClick(rowIndex, colIndex) {
                this.dataEditColumn.rowIndex = rowIndex
                this.dataEditColumn.colIndex = colIndex
                this.$refs.modalFormColumn.open = true
            }
        }
    }
</script>